/**
 * Reports — Report sources (#239). `/reports/sources`.
 *
 * The library's WigReportSources: list, create, preview, edit, publish and
 * delete SQL report sources. A published source becomes report dataset
 * `src_<key>`. The six source calls come from useReportsDataSource.
 *
 * BD.Admin only, the same gate as the builder: the page self-redirects
 * without `reports.manage`, and every /reports/sources endpoint is admin-only
 * on the server, which is the boundary.
 */
import React, { useContext, useEffect } from "react";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import { Row } from "antd";
import { useNavigate } from "react-router";

import { WigAntLayout } from "@warwick-investment-group/wig-react-library";
import { WigReportSources } from "@warwick-investment-group/wig-react-library/reports";

import SignIn from "../signIn";
import { AppContext } from "../../AppContextProvider";
import usePermissions from "../../hooks/usePermissions";
import useReportsDataSource from "../../hooks/useReportsDataSource";
import { reportLayoutProps } from "./layout";

const ReportSources = () => {
  const navigate = useNavigate();
  const { theme } = useContext(AppContext);
  const { can } = usePermissions();
  const allowed = can("reports.manage");
  const { dataSource } = useReportsDataSource();

  useEffect(() => {
    if (!allowed) navigate("/", { replace: true });
  }, [allowed, navigate]);

  if (!allowed) return null;

  return (
    <React.Fragment>
      <AuthenticatedTemplate>
        <Row>
          <WigAntLayout
            {...reportLayoutProps(theme === "dark")}
            // WigReportSources renders its own heading and "New source".
            content={<WigReportSources dataSource={dataSource} />}
          />
        </Row>
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <SignIn />
      </UnauthenticatedTemplate>
    </React.Fragment>
  );
};

export default ReportSources;
